// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2kAwJ","footer":"Form_footer__Joy9Y"};